module.exports = __webpack_public_path__ + "static/media/1005386.c543a474.jpg";